import { render, staticRenderFns } from "./Ingrediente.vue?vue&type=template&id=9688b4be&scoped=true&"
import script from "./Ingrediente.vue?vue&type=script&lang=js&"
export * from "./Ingrediente.vue?vue&type=script&lang=js&"
import style0 from "./Ingrediente.vue?vue&type=style&index=0&id=9688b4be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9688b4be",
  null
  
)

export default component.exports